import Reveal from "@/components/Reveal";
import { imgUrl } from "@/lib/api";

export function Stats({ stats = [] }) {
  return (
    <section className="border-b border-black/10 bg-[#EBECE8]" data-testid="stats-strip">
      <div className="max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-4">
        {stats.map((s, i) => (
          <Reveal key={i} delay={i * 0.08} className={`px-6 py-10 border-black/10 ${i % 2 === 0 ? "border-r" : ""} md:border-r md:last:border-r-0`}>
            <p className="font-display font-extrabold text-3xl md:text-4xl text-citek-greenDark" data-testid={`stat-value-${i}`}>
              {s.value}
            </p>
            <p className="mt-3 text-base font-medium text-zinc-800">{s.label}</p>
            <p className="mt-1 font-tech text-xs uppercase tracking-[0.18em] text-zinc-500">{s.sub}</p>
          </Reveal>
        ))}
      </div>
    </section>
  );
}

function ServiceCard({ item, index }) {
  const span = item.span || "col-span-full";
  const hasImage = !!item.image;
  return (
    <Reveal
      delay={index * 0.07}
      className={`${span} min-h-[230px]`}
    >
      <article
        data-testid={`service-card-${item.id || index}`}
        className="group relative h-full overflow-hidden rounded-lg border border-black/10 bg-white hover:border-citek-green/60 hover:shadow-lg hover:shadow-citek-green/10 transition-all duration-300"
      >
        {hasImage && (
          <img
            src={imgUrl(item.image)}
            alt={item.title}
            className="absolute inset-0 w-full h-full object-cover opacity-25 group-hover:opacity-35 group-hover:scale-105 transition-all duration-700"
          />
        )}
        {hasImage && <div className="absolute inset-0 bg-gradient-to-t from-white via-white/75 to-white/25" />}

        <span className="absolute left-0 top-6 h-10 w-[3px] bg-citek-green/0 group-hover:bg-citek-green transition-all duration-300" />

        <div className="relative z-10 h-full flex flex-col p-6 md:p-8">
          <p className="font-tech text-xs uppercase tracking-[0.25em] text-citek-greenDark">{item.tag}</p>
          <h3 className="mt-3 font-display font-bold uppercase tracking-tight text-zinc-900 text-xl md:text-2xl">
            {item.title}
          </h3>
          <p className="mt-3 text-base leading-relaxed text-zinc-600 max-w-md">{item.description}</p>
          {item.badge && (
            <span className="mt-auto pt-5">
              <span className="inline-block clip-chamfer bg-citek-green/10 border border-citek-greenDark/30 px-3 py-1.5 font-tech text-[11px] uppercase tracking-[0.2em] text-citek-greenDark">
                {item.badge}
              </span>
            </span>
          )}
        </div>
      </article>
    </Reveal>
  );
}

export function Services({ services }) {
  return (
    <section id="metiers" className="py-24 md:py-32 bg-[#EBECE8] scroll-mt-20" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <Reveal>
          <p className="font-tech text-sm uppercase tracking-[0.24em] text-citek-greenDark" data-testid="services-kicker">
            {services.kicker}
          </p>
          <h2 className="mt-4 font-display font-extrabold uppercase tracking-tight text-zinc-900 text-3xl md:text-5xl max-w-3xl leading-[1.05]" data-testid="services-title">
            {services.title}
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-12 md:auto-rows-[235px] gap-4">
          {services.items.map((item, i) => (
            <ServiceCard key={item.id || i} item={item} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
